import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import LogoMenu from './LogoMenu'
import NavBarNotifications from 'components/Dashboard/NavBar/NavBarNotifications'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import { useAppSelector } from 'store/hooks'

export default function NavBarHeader(): ReactElement {
  const isNavBarExpanded = useAppSelector(s => s.dashboard.isNavBarExpanded)
  const isDesktop = useBreakpointIndex() === 2

  return (
    <Flex
      data-testid="nav-bar-header"
      sx={{
        position: 'relative',
        mb: '0.8rem',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <LogoMenu />
      {isNavBarExpanded && isDesktop && <NavBarNotifications />}
    </Flex>
  )
}
